import React from 'react';

import { AsyncOutrightPage } from 'modules/outright/async';

interface Props {
    matchId: string;
}

const Outright: React.FC<Props> = ({ matchId }) => (
    <AsyncOutrightPage matchId={matchId} />
);

export default Outright;
